goog.provide('el8.appchart.refpanel.maintItems');

goog.require('el8.app.shared.clickItemOpts');
goog.require('el8.app.shared.dialog.reportAttachments');
goog.require('el8.appshared.form.buttons');
goog.require('el8.data.docTags');
goog.require('el8.ptdata.fetch');
goog.require('el8.service.tz');
goog.require('el8.uiwidget.confirm');
goog.require('el8.uiwidget.GroupedNav');
goog.require('el8.util.consts');

goog.require('el8.appchart.showItemDetail');
goog.require('el8.appchart.cqmRefresh');
goog.require('el8.template.appchart.refpanel.maintItems');

goog.require('el8.data.maintItemRules');
goog.require('el8.ptdata.ptMaintItems');


//
// This is the two-pane maint items dialog shown when a maint item rule is clicked in the LHS.
//
el8.appchart.refpanel.maintItems = function() {
    var form = null;
    var currentItemId = null; // "real" HM item
    var currentSourceId = null; // "virtual" HM item from ambient satisfaction
    var currentEntityId = null; // i.e linked report
    var ruleId = null;
    var measureId = null;
    var vItems = [];
    var vItemsQueryDate = null;
    var allItems = [];

    var that = new el8.uiwidget.NewDialog({
        title: 'Add/Edit Maintenence Items',
        autoHeight: true,
        showXButton: true,
        contentFn: function() { return el8.template.appchart.refpanel.maintItems.content(); }
    });

    that._saveFn = function () {
        // Form will exist since there's no "save" for virtual/ambient items
        var mapped = form.getMapped();
        mapped.ruleId = ruleId;

        // Check for future dates
        if (el8.util.datecompare.isAfterToday(el8.util.datecompare.dateFromStr(mapped.date))) {
            el8.uiwidget.nonAlarmingAlert('Please select a date of today or earlier');
            return false;
        }

        // set physicianId if selected, and rm from map
        if (form.getClickItemId('provider')) {
            mapped.physicianId = form.getClickItemId('provider');
        } else {
            mapped.physicianId = null;
        }
        delete mapped.provider;

        // set or clear reportId
        mapped.reportId = currentEntityId;

        // get a single docTagId from the form if there's a taginput or just the single
        // docTagId from the rule itself
        var rule = el8.data.maintItemRules.getById(ruleId);
        var docTagId = null;
        if (rule.getDocTagIds().length > 1) {
            docTagId = _.first(form.getVal('docTags'));

            // Require a doctag if there's a set to select from
            if (!docTagId) {
                el8.uiwidget.nonAlarmingAlert('Please select a type');
                return false;
            }

        } else {
            docTagId = _.first(rule.getDocTagIds());
        }
        mapped.docTagId = docTagId;

        var successCb = function () {
            that.hide();
            return false;
        };

        if (!currentItemId) {
            el8.ptdata.ptMaintItems.saveNew(mapped, false, {successCb: successCb});
        } else {
            var item = el8.ptdata.ptMaintItems.getById(currentItemId);
            el8.ptdata.ptMaintItems.saveItem(
                item.populate(mapped),
                false,
                {successCb: successCb}
            );
        }

        return false;
    };

    that._tagInputOpts = function (docTagsIds) {
            return {
                mindreaderOpts: $.extend(el8.appshared.mindreaderOpts.maintItemRuleDocumentTags(docTagsIds), {
                    focusAfterSelect: false,
                    showOnFocusOnce: true,
                    infoText: 'Select a specific tag...',
                    modifyRenderCb: function(params) { params.infoDiv.text(''); }
                }),
                changeFn: function (){ that.adjustHeight();},
                oneOnly: true,
                noPromptCreateTag: true
            };
    };

    that._createFields = function (rule) {
        var docTagsIds = rule.getDocTagIds();

        var fields = [{
            name: 'date',
            selector: ':input[name="date"]',
            infoText: 'date...',
            datePickerOpts: { maxDate: el8.service.tz.today() },
            defaultVal: function() { return el8.service.tz.today().asString(); },
            validate: {
                validDate: true,
                todayOrBefore: true,
                required: true
            }
        }];

        // Only show field if more than 1 doctag for this rule
        if (docTagsIds.length > 1) {
            $('.type-container', that.getContentElt()).show();
            fields.push({
                name: 'docTags',
                selector: '.doctags-holder',
                newMindreader: true,
                tagInputOpts: that._tagInputOpts(docTagsIds)
            });
        } else {
            $('.type-container', that.getContentElt()).hide();
        }

        // stuff for the physicians clickitem
        var _cio = el8.app.shared.clickItemOpts.physicians({
            newContactCb: function(contact) {
                if (!contact) { return; }

                form.setClickItemSelected('provider', {
                    id: contact.getId(),
                    name: contact.getFullName()
                });
            }
        });
        var localClickItemOpts = $.extend({}, _cio, {changeFn: function (){ that.adjustHeight(); } });

        var nextFields = [
            {
                name: 'note',
                selector: ':input[name="note"]',
                infoText: 'notes...',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT * 4,
                validate: { required: true }
            },
            {
                name: 'provider',
                selector: '.provider',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                infoText: 'referring provider...',
                clickItemOpts: localClickItemOpts
            }
        ];

        return fields.concat(nextFields);
    };

    that._createForm = function(rule) {
        var addEditContainer = $('.add-edit-container', that.getContentElt());
        form = new el8.uiwidget.Form({
            container: $('.add-new-maint-item-form', addEditContainer),
            buttonElt: $('.add-new-button-elt', addEditContainer),
            fields: that._createFields(rule),
            validationOpts: el8.util.validate.standardOpts
        });
        form.addButton('save', 'Save New', function(_form) { that._saveFn(); }, true);
        form.addButton('discard', 'Discard', function(_form) {
            var successCb = function () {
                // Hide first to avoid race with reloading rules
                that.hide();
                el8.appchart.refpanel.maint.render(true);
            };

            var item = el8.ptdata.ptMaintItems.getById(currentItemId);

            if (item) {
                el8.ptdata.ptMaintItems.deleteItem(
                    item,
                    false,
                    {successCb: successCb}
                );
            } else {
                // nothing to discard, just close
                that.hide();
            }
        });
    };

    that._clearItemList = function() {
        var contentElt = that.getContentElt();
        if (contentElt) {
            $('.maint-items-list-pane', that.getContentElt()).empty();
        }
        allItems = [];
    };

    that._renderItemList = function (ruleId, measureId) {

        var listPaneElt = $('.maint-items-list-pane', that.getContentElt());

        var items = el8.ptdata.ptMaintItems.getByRuleId(ruleId);

        // Dedup virtualItems based on real HM items
        var realItemIds = _.map(items, function(i) { return i.getId(); });
        var virtualItems = _.reject(vItems, function (vi) {
            var rejected = _.contains(realItemIds, vi.getSourceId());
            if (!rejected) {
                // do a server fetch to confirm if the source has been deleted
                // a virtual item pointing to a source that has been deleted
                // should not be valid
                if (el8.ptdata.isDeleted(vi.getSourceId())) {
                    rejected = true;
                }
            }
            return rejected;
        });

        allItems = _.chain(items.concat(virtualItems))
                    .sortBy(function (item) { return item.getDate(); })
                    .reverse()
                    .value();
        var allItemSoyMaps = _.map(allItems, function(item) { return item.asSoyMap(); });

        listPaneElt.html(
            el8.template.appchart.refpanel.maintItems.list({
                rule: el8.data.maintItemRules.getById(ruleId).asSoyMap(),
                items: allItemSoyMaps,
                currentItemOrSourceId: currentItemId || currentSourceId || null
            })
        );

        that.adjustHeight();
    };

    that._showAddReportLink = function () {
        $('.link-report-trigger', that.getContentElt()).show();
        $('.view-report-trigger', that.getContentElt()).hide();
        $('.remove-report-trigger', that.getContentElt()).hide();
    };

    that._showViewRemoveReportLinks = function () {
        $('.link-report-trigger', that.getContentElt()).hide();
        $('.view-report-trigger', that.getContentElt()).show();
        $('.remove-report-trigger', that.getContentElt()).show();
    };

    that.showView = {};
    that.showView.createForm = function() {
        form.reset();
        form.updateButtonCaption('save', 'Save New');
        form.updateButtonCaption('discard', 'Discard');
        that._showAddReportLink();

        currentItemId = null;
        currentEntityId = null;
        currentSourceId = null;

        that.setActiveView($('.add-edit-container', that.getContentElt()));
        that.setMenuActiveItem($('.add-new-trigger', that.getContentElt()));
    };

    that.showView.ambientItem = function (vItem) {
        var sourceItem = el8.ptdata.fetchById(vItem.getSourceId());

        // Rm any existing virt item, insert new
        $('.ambient-item-container', that.getContentElt()).remove();
        $('.maint-items-detail-pane', that.getContentElt()).append(
            el8.template.appchart.refpanel.maintItems.ambientOrExclusionItem({
                item: sourceItem.asSoyMap(),
                reasonDescription: vItem.getDescription(),
                codeType: vItem.getCodeType(),
                code: vItem.getCode(),
                exclusionYear: vItem.isExclusionItem() ? new Date(vItemsQueryDate).getFullYear() : null
            })
        );

        that.setActiveView($('.ambient-item-container', that.getContentElt()));
    };

    that.showView.maintItem = function(item) {
        form.populate(item.asSoyMap());

        // manually populate taginput
        if (form.getTagInput('docTags') && item.getDocTagId()) {
            var tagInput = form.getTagInput('docTags');
            tagInput.reset();

            var tag = el8.data.docTags.getById(item.getDocTagId());
            tagInput.addTag(tag.asSoyMap());
        }

        // manually populate physician
        if (item.getPhysicianId()) {
            form.setClickItemSelected('provider', {
                id: item.getPhysicianId(),
                name: item.getPhysicianName()
            });
        }

        if (currentEntityId) {
            that._showViewRemoveReportLinks();
        } else {
            that._showAddReportLink();
        }

        form.updateButtonCaption('save', 'Update');
        form.updateButtonCaption('discard', 'Delete');

        that.setActiveView($('.add-edit-container', that.getContentElt()));
    };

    that.showView.description = function() {
        that.setMenuActiveItem($('.description-trigger', that.getContentElt()));
        that.setActiveView($('.measure-description-container', that.getContentElt()));

    };

    that.setMenuActiveItem = function(activeElt) {
        $('.el8NavMenuItemSelected', that.getContentElt()).removeClass('el8NavMenuItemSelected').addClass('el8NavMenuItem');
        activeElt.removeClass('el8NavMenuItem').addClass('el8NavMenuItemSelected');
    };

    that.setActiveView = function(activeElt) {
        $('.view-pane', that.getContentElt()).hide();
        if (activeElt) {
            activeElt.show();
        }
        that.adjustHeight();
    };

    that._bindTriggers = function () {
        that.getContentElt()
            .on('click', '.add-new-trigger',  function(e) {
                that.showView.createForm();
            })

            .on('click', '.description-trigger',  function(e) {
                that.showView.description();
            })

            .on('click', '.item-trigger',  function(e) {
                // if this is null, it's virtual reason item
                var linkElt = $('.select-trigger', $(this));
                var itemId = linkElt.data('id');
                var sourceId = linkElt.data('source-id');

                if (itemId) {
                    var item = el8.ptdata.ptMaintItems.getById(itemId);
                    currentItemId = itemId;
                    currentSourceId = null;
                    currentEntityId = item.getReportId();

                    that.showView.maintItem(item);
                } else {
                    currentItemId = null;
                    currentSourceId= sourceId;
                    currentEntityId = null;

                    var vItem = _.filter(vItems, function(i) {
                        return i.getSourceId() === sourceId;
                    })[0];

                    that.showView.ambientItem(vItem);
                }

                that.setMenuActiveItem($(this));
            })

            .on('click', '.item-details-trigger',  function (e) {
                var itemId = $(this).data('id');
                el8.appchart.showItemDetail(itemId);
                return false;
            })

            .on('click', '.link-report-trigger',  function(e) {
                // open attachment dlg
                el8.app.shared.dialog.reportAttachments.show({
                    callbackFn: function (attachmentItems) {
                        // just one or none
                        if (attachmentItems.length) {
                            var attachment = attachmentItems[0];
                            currentEntityId = attachment.getId();
                            // hide/show links
                            that._showViewRemoveReportLinks();
                        }
                    }
                });
                return false;
            })

            .on('click', '.view-report-trigger',  function(e) {
                el8.appchart.showItemDetail(currentEntityId);
                return false;
            })

            .on('click', '.remove-report-trigger',  function(e) {
                currentEntityId = null;
                that._showAddReportLink();
            });
    };

    function refreshVirtualItems() {
        vItems = [];
        vItemsQueryDate = el8.appchart.cqmRefresh.getReportingDate();
        if (!measureId) { return $.Deferred().reject().promise(); }

        return el8.appchart.cqmRefresh.fetchMeasureGuidance(measureId).done(function (guidanceData) {
            var cqmStatus = el8.appchart.cqmRefresh.cqmStatus;
            if (!cqmStatus.results) { return; }

            var measureResults = cqmStatus.results[measureId];
            if (!measureResults) { return; }

            var measureReminders = cqmStatus.reminders[measureId];
            if (!measureReminders) { return; }

            var labelsFromGuidance = el8.shared.util.cqm.parseLabelsFromGuidance(guidanceData.guidance);

            // Assumption: reminders (if there are multiple in this measure) won't use the same label
            // in different roles, e.g. in both $excluded and $pending
            var labelsToSearch = {};
            _.each(measureReminders.spec.reminders, function(reminder) {
                Object.assign(labelsToSearch, el8.shared.util.cqm.extractGuidanceLabelsForReminder(reminder, labelsFromGuidance));
            });

            _.each(labelsToSearch, function(labelMeta, label) {
                var record = el8.shared.util.cqm.findRecord(measureResults.timelapse_map[label], vItemsQueryDate);

                if (record && record.result) {
                    var codeType = null;
                    var code = null;
                    if (record.result.code) {
                        var systemAndCode = record.result.code.split(',');
                        codeType = guidanceData.code_system_names[systemAndCode[0]];
                        code = systemAndCode[1];
                    }

                    vItems.push(new el8.data.maintItemRules.maintItemRuleReason({
                        sourceId: record.result.source,
                        date: el8.service.tz.toTzDateTime(record.result.start),
                        description: labelMeta.labelInfo.cleanedText,
                        codeType: codeType,
                        code: code,
                        exclusionItem: labelMeta.reminderStateLabel === '$excluded'
                    }));
                }
            });
        }).then(function() {
            that._renderItemList(ruleId, measureId);
        });
    }

    el8.appchart.cqmRefresh.register({
        updateCb: function(url, changed) {
            if (changed) {
                refreshVirtualItems();
            }
        }
    });

    function selectDefaultIfNeeded() {
        var currentItem = _.find(allItems, function(item) {
            return (currentItemId && item.getId && item.getId() === currentItemId) ||
                   (currentSourceId && item.getSourceId && item.getSourceId() === currentSourceId);
        });

        if (!currentItem) {
            if (allItems.length > 0) {
                $('.item-trigger', that.getContentElt())[0].click();
            }
            else {
                $('.add-new-trigger', that.getContentElt()).click();
            }
        }
    }

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that._bindTriggers();
        el8.data.maintItemRules.softLoad();
        el8.ptdata.ptMaintItems.load();
    };

     //
     // Spec:
     //     title: the name of the HM item set
     //     ruleId: to filter the items entity set
     //     itemId (optional)
     //
    var super_show = that.show;
    that.show = function(spec) {
        var newMeasureId = _.invert(el8.appchart.cqmRefresh.cqmStatus.health_maint_id_map)[spec.ruleId];
        if (measureId !== newMeasureId) { that.reset(); }
        measureId = newMeasureId;
        ruleId = spec.ruleId;
        super_show.call(that);

        var rule = el8.data.maintItemRules.getById(ruleId);

        // Inject the addEditForm even if we're not showing it immediately
        $('.maint-items-detail-pane', that.getContentElt()).empty().append(
              el8.template.appchart.refpanel.maintItems.addEditForm()
        ).append(
            el8.template.appchart.refpanel.maintItems.description({
              cdsIdentifier: el8.appchart.cqmRefresh.cqmStatus.cds_identifier_map[measureId] ||
                             el8.appchart.cqmRefresh.cqmStatus.results[measureId].measure_code
            })
        );

        that._createForm(rule);
        form.render();

        that.setActiveView(null);
        refreshVirtualItems().then(selectDefaultIfNeeded);
        that.setTitle(spec.title + ' Items');
    };

    that.reset = function() {
        currentItemId = null;
        currentSourceId = null;
        currentEntityId = null;
        ruleId = null;
        measureId = null;
        vItems = null;
        vItemsQueryDate = null;
        that._clearItemList();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        that.reset();
    };

    return that;
};
